import * as React from 'react';
import Image from '../../components/Image';
import CountryService from '../../services/CountryService';
import { Radio } from '../../components/FormGenerator/modules';
import { CurrencyFormatter as Currency } from '../../utils/utils';
import { findPrice } from '../../helpers/prices';
import { getPriceWithoutVat } from 'data-layer/src/helpers/prices/getPriceWithoutVat';
import { vatDescription } from '../../helpers/vatDescription';

interface IPaymentMethodsProps {
  fieldName: string;
  selected: any;
  paymentMethods: Array<GQL.IPaymentMethod>;
  errorMessage?: string;
  onChange: (e: any) => void;
}

class PaymentMethods extends React.Component<IPaymentMethodsProps> {

  public render() {
    const { fieldName, selected, errorMessage } = this.props;
    const { language, VATrate } = CountryService.GetInstance();
    const hasImages = false;

    return (
      <div className="payment-methods">
        {errorMessage &&
          <p className={'form__error form__error--static'}>
            {errorMessage}
          </p>}
        <table className="table table--form">
          <tbody>
            {this.props.paymentMethods &&
              this.props.paymentMethods.map((paymentMethod: GQL.IPaymentMethod, i: number) => {

                const label =
                  <span>
                    {hasImages &&
                      <div className="image">
                        <Image image={paymentMethod.image} />
                      </div>}
                    {paymentMethod.name[language]}
                    {paymentMethod.description && paymentMethod.description[language] &&
                      <React.Fragment>
                        <br />
                        <span className="description" dangerouslySetInnerHTML={{ __html: ('' + paymentMethod.description[language]).replace(/\n/g, '<br>') }} />
                      </React.Fragment>}
                  </span>;

                const paymentPrice = findPrice(paymentMethod.prices, false, VATrate, paymentMethod);

                return (
                  <tr key={i} className={`method${selected === paymentMethod.id ? ' active' : ''}`}>
                    <td className="table__radio">
                      <Radio
                        fieldName={fieldName}
                        value={paymentMethod.id}
                        checked={selected === paymentMethod.id}
                        label={label}
                        onChange={(e: any) => this.onChange(e)}
                      />
                    </td>
                    <td className="table__price">
                      <Currency price={getPriceWithoutVat(paymentPrice, VATrate)} decimals={2} />
                      {VATrate > 0 && paymentPrice > 0 &&
                        <>
                          <br />
                          <span className="withoutVat">
                            <Currency price={paymentPrice} /> incl. {vatDescription()}
                          </span>
                        </>}
                    </td>
                  </tr>
                );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  private onChange(e: any) {
    this.props.onChange({
      target: {
        name: this.props.fieldName,
        value: this.props.paymentMethods.find((pm: GQL.IPaymentMethod) => pm.id === e.target.value),
      }
    });
  }
}

export default PaymentMethods;


// WEBPACK FOOTER //
// ./src/components/PaymentMethods/PaymentMethods.tsx